import { Image, Person, UseRowsReturn } from '@nettbureau/featured-core';
import { ContactCard } from '../card/ContactCard';
import { Featured } from '../featured/Featured';

interface PeopleSectionProps {
  people: UseRowsReturn<Person>;
  containerTitle: string;
  defaultBackground: Image | null;
}

export function PeopleSection({
  people,
  containerTitle,
  defaultBackground,
}: PeopleSectionProps) {
  return (
    <Featured<Person>
      rows={people}
      contactUrl={null}
      title={containerTitle}
      cardRenderer={(attributes, index) => {
        return (
          <ContactCard
            id={attributes.id}
            key={index}
            /** Not really relevant for people. */
            subscriptionLevel="premium"
            icon={attributes.icon}
            logo={attributes.logo}
            href={null}
            center={attributes.center}
            subTitle={attributes.companyName}
            website={attributes.website}
            background={attributes.background ?? defaultBackground}
            email={attributes.email}
            phone={attributes.phone}
            bodyLine2={attributes.subTitle}
            bodyLine1={attributes.title}
            title={attributes.name}
          />
        );
      }}
    />
  );
}
